import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Autocomplete,
  Grid,
  TextField,
  Tooltip,
  Typography,
  createFilterOptions,
} from "@mui/material";
import jwt_decode from "jwt-decode";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as FilterIcon } from "../../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../src/assets/Customer/FilterIconHover.svg";
import CommonUtil from "../../Util/CommonUtils";
import { allHostList } from "../../slices/HostSlice";
import { getPurposeType } from "../../slices/PurposeTypeGlobalUSA/PurposeTypeGlobalSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import Toast from "../ToastContainer/CustomToast";
import DialogBox from "./DialogBox";

export default function FilterForm(props) {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [hostList, setHostList] = useState([]);
  const [selectedHost, setSelectHost] = useState([]);
  const [purposeData, setPurposeData] = useState([]);

  const [selectedValue, setSelectedValue] = useState(null);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [isHovered, setIsHovered] = useState(false);

  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  );

  const [payload, setPayload] = useState({
    hostId: "",
    purposeTypeId: "",
    status: "",
    visitMode: props.visitMode,
  });

  const handleClose = () => {
    setSelectHost("");
    setSelectedValue(null);
    setPayload({
      hostId: "",
      purposeTypeId: "",
      status: "",
      visitMode: props.selectedObject,
    });
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  const [error, setError] = useState({
    hostId: false,
    purposeTypeId: false,
  });

  if (open) {
    setDiaLogBoxBlur(true);
  }
  const reset = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });

    setError({
      [name]: false,
    });
  };

  const handleStatusChange = (event, value) => {
    setPayload({
      ...payload,
      status: value,
    });
  };

  const handlePurposeTypeChange = (event, value) => {
    if (value) {
      setSelectedValue(value);
      setPayload({
        ...payload,
        purposeTypeId: value.id,
      });
    } else {
      setSelectedValue(null);
      setPayload({
        ...payload,
        purposeTypeId: "",
      });
    }
  };

  const statusValue = props.status;

  const loadData = () => {
    loadPurposeType();
    loadHosts();
  };

  const loadPurposeType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
      status: "ACTIVE",
    };

    dispatch(getPurposeType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setPurposeData(data.data.purposeTypes);
        } else {
          setPurposeData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const loadHosts = () => {
    const payload = {
      pageNumber: 1,
      pageSize: 0,
      email: decoded_jwtToken.email,
    };
    dispatch(allHostList(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "OMSI0000") {
          //  getSelectedItem(data.data.employees[0]);
          setHostList(data.data.employees);
        } else {
          getSelectedItem();
          setHostList([]);
        }
      });
  };

  const handleSubmit = () => {
    if (
      payload.purposeTypeId.trim() === "" &&
      payload.hostId.trim() === "" &&
      payload.status === ""
    ) {
      Toast(t("COMMON015"), "error");
      return;
    }

    props.applyFilter(payload);
    setSelectHost("");
    setSelectedValue(null);
    setPayload({
      hostId: "",
      purposeTypeId: "",
      status: "",
    });
    handleClose();
  };

  const onselectPurposeType = (event) => {
    setPayload({
      ...payload,
      purposeTypeId: event.id,
    });
  };

  const onselectHost = (event) => {
    setPayload({
      ...payload,
      hostId: event.id,
    });
  };

  const getSelectedItem = (newValue) => {
    if (newValue != null) {
      setPayload({
        ...payload,
        hostId: newValue.id,
      });
      setSelectHost(newValue);
    } else {
      setPayload({
        ...payload,
        hostId: "",
      });
      setSelectHost({});
    }
  };

  const handleText = (event) => {
    if (CommonUtil.isValidEmails(event.target.value)) {
      console.log(event.target.value);
      const payload = {
        pageNumber: 1,
        pageSize: 0,
        email: event.target.value,
      };
      dispatch(allHostList(payload))
        .unwrap()
        .then((data) => {
          if (data.code === "OMSI0000") {
            if (!CommonUtil.isEmptyArray(data.data)) {
              // getSelectedItem(data.data.employees[0]);
              setHostList(data.data.employees);
            } else {
              setHostList([]);
              getSelectedItem(null);
            }
          }
        });
    }
  };

  const filterOptions = createFilterOptions({
    stringify: ({ firstName, email }) => `${firstName} ${email}`,
    limit: 1,
  });

  const formatStatus = (value) => {
    if (!value) return "";

    return value
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <>
      <Tooltip
        title={
          <Typography fontSize={12} fontWeight={500}>
            {t("COMMON006")}
          </Typography>
        }
      >
        <span
          style={{
            marginLeft: "-10px",
            marginTop: "2px",
          }}
          className={darkMode ? "filterdark" : "filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => {
            setOpen(true);
            loadData();
          }}
        >
          {isHovered ? (
            <FilterIconHover
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <FilterForm />
            </FilterIconHover>
          ) : (
            <FilterIcon
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <FilterForm />
            </FilterIcon>
          )}
        </span>
      </Tooltip>
      {/* </Box> */}

      <DialogBox
        Header={
          <span style={{ color: darkMode ? "#fff" : "#3D4977" }}>
            {t("COMMON006")}
          </span>
        }
        acceptText={t("COMMON024")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={handleClose}
      >
        <Grid
          container
          spacing={1.8}
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
          }}
        >
          <Grid item xs={12} sm={12}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              filterOptions={filterOptions}
              options={hostList}
              getOptionLabel={(option) =>
                option.lastName
                  ? option.firstName + " " + option.lastName
                  : option.firstName
                  ? option.firstName
                  : ""
              }
              value={selectedHost}
              disableClearable={!selectedHost}
              onChange={(event, newValue) => {
                getSelectedItem(newValue);
                setError({ selectedHost: false });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("commonsTextFeildHostValue")}
                  required={false}
                  name="hostId"
                  key="Confirmation Code"
                  id="hostId"
                  handleChange={(e) => handleText(e)}
                  error={error.selectedHost}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              options={purposeData}
              name="purposeTypeId"
              error={error.purposeTypeId}
              getOptionLabel={(option) => option.name}
              value={selectedValue}
              onChange={handlePurposeTypeChange}
              renderInput={(params) => (
                <TextField {...params} label={t("PURPOSETYPE")} />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              options={CommonUtil.isEmptyArray(statusValue) ? [] : statusValue}
              onChange={handleStatusChange}
              getOptionLabel={(option) => formatStatus(option)}
              renderInput={(params) => (
                <TextField {...params} label={t("COMMON001")} />
              )}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
